import * as React from 'react';
import {Main} from "../components/Main";
import {Box} from "../components/sharedComponents/Box";
import reg from './Regulamin_21-02-16'
import html from './htmlStatute'
import {useEffect, useState} from "react";
import Services from "../utilities/Services";
import {notify} from "../utilities/notify";
import {isEmpty} from "../utilities/Utilities";

interface Props {
}

export const Statute = (props: Props) => {
    const [regulamin, setRegulamin]: any = useState();

    useEffect(() => {
        pobierzRegulamin();
    }, [])

    const pobierzRegulamin = React.useCallback(() => {
        Services.getTrescHtml('REGULAMIN', 'PL').then((response) => {
            setRegulamin(response.data);
        }).catch((e) => {
            notify.error('Nie udało się pobrać regulaminu.', 'Błąd');
        })
    }, [])

    return <Main active={'STATUTE'} title={'Regulamin'}>
        <h1 className={'sr-only'}>Regulamin</h1>
        {/*{(isEmpty(regulamin)) ?*/}
        {/*    <h5>Ładowanie...</h5>*/}
        {/*    :*/}
        {/*    <Box>*/}
        {/*        <div dangerouslySetInnerHTML={{__html: regulamin.tresc}} style={{height: '100%'}}/>*/}
        {/*    </Box>*/}
        {/*}*/}

        <div className={'statute'}>
            {(isEmpty(regulamin))?
                <p className={'h5'} role={'status'}>Ładowanie...</p>
                :
                regulamin.map((reg: any, i: number) =>
                    <details key={i}>
                        <summary>{reg.tytul}</summary>
                        <Box style={{margin: '10px'}}><div dangerouslySetInnerHTML={{__html: reg.tresc}} style={{height: '100%'}}/></Box>
                    </details>
                )}
        </div>


        {/*<Box>*/}
        {/*    <div dangerouslySetInnerHTML={{__html: html}} style={{height: '100%'}}/>*/}
        {/*</Box>*/}
        {/*<Box>*/}
        {/*    <div dangerouslySetInnerHTML={{__html: reg}} style={{height: '100%'}}/>*/}
        {/*</Box>*/}
    </Main>

}

Statute.defaultProps = {}

